module.exports = __webpack_public_path__ + "static/img/we_image.d57a5f3.png";


//////////////////
// WEBPACK FOOTER
// ./src/common/ter/images/we_image.png
// module id = +Vdu
// module chunks = 0